import React, { useState, useEffect } from 'react';

import { convertPercentToPrecision } from 'src/components/JobDatasheet/utils';
import { QuestionPercentDefaultProps, QuestionPercentPropTypes } from 'src/components/JobDatasheet/propTypes';
import { noop } from 'src/utils/core/event';
import { EiqInput } from 'eiq-storybook';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionPercent = ({
  errors,
  flash,
  isRectifiedQuestion,
  question,
  onChange,
  readonly,
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const [localValue, setLocalValue] = useState('');

  useEffect(() => {
    setLocalValue(value);
  }, [value?.value, value?.rectifiedValue]);

  let numberValue = (localValue || { value: '' })[selectedValueKey];
  if (!numberValue && numberValue !== 0) {
    numberValue = '';
  }
  // eslint-disable-next-line prefer-destructuring
  const length = numberValue.toString().length;

  const getReturnObject = val => {
    const returnObject = {
      ...value,
      type: 'percent'
    };

    returnObject[selectedValueKey] = convertPercentToPrecision(val);

    return returnObject;
  };

  return (
    <s.QuestionNumberPercentTimeWrapper>
    <EiqInput
    errorMessage={(errors || []).join(' & ')}        
    type='number'
    placeholder='%'
    isPercentage={true}
    min={0}
    max={100}
    onBlur={!disableChange ? (e) => {
      if (!readonly && (e.target.value !== value?.value)) {
        onChange(getReturnObject(e.target.value));
      }
    } : noop}
    defaultValue={value}
    id={`question-percent-input-${question?.id}`}
    wrapperClassName={'eiqInput'}
    onChange={!disableChange ? (e) => {
      if (!readonly) {
        onChange(getReturnObject(e.target.value));
      } else {
        setLocalValue(getReturnObject(e.target.value));
      }
    } : noop}
    value={numberValue || ''}
    />
    </s.QuestionNumberPercentTimeWrapper>
  );
};

QuestionPercent.propTypes = QuestionPercentPropTypes;
QuestionPercent.defaultProps = QuestionPercentDefaultProps;
